import React, { useState, useEffect } from 'react';
import { Form, Input, message } from 'antd';
import SpeechRecognition from 'react-speech-recognition'
import renderElement from './formAnswers/renderElement';
import ImageComp from './formAnswers/imgComp';
import moment from 'moment';

const RenderResponseWithAnsChat = (props) => {

  const [uploadList, setuploadList] = useState([])
  const [flag, setflag] = useState(null)
  const [submitDone, setsubmitDone] = useState(false)
  const [voiceInput, setvoiceInput] = useState(null)
  const [p, setp] = useState(props.record)
  const [loading, setloading] = useState(true)
  const [speechstarted, setspeechstarted] = useState(false)
  const [selectedArea, setselectedArea] = useState(null)

  // const [speechprocessing, setspeechprocessing] = useState(false)


  ///---------- add 'not applicable' option in radio and checkbox ----------///
  useEffect(() => {
    let rec = props.record;
    if (props.record.questionType == 'CHECK_BOX' && props.record.addNotApplicable) {
      let obj = rec.checkboxList.find((item) => item.optionTitle == "Not Applicable")
      if (!obj) {
        rec.checkboxList.push({
          freeTextRequired: false,
          optionSummary: `${props.record.questionTitle} : Not Applicable`,
          optionTitle: "Not Applicable"
        })
      }
    }
    if (props.record.questionType == 'RADIO_BUTTON' &&  props.record.addNotApplicable) {
      let obj = rec.radioList.find((item) => item.optionTitle == "Not Applicable")
      if (!obj) {
        rec.radioList.push({
          freeTextRequired: false,
          optionSummary: `${props.record.questionTitle} : Not Applicable`,
          optionTitle: "Not Applicable"
        })
      }
    }
    setp(rec)
    setloading(false)
  }, [])




/// ---------------------------------------
  useEffect(() => {
    if (props.formReseted == true) {
      setsubmitDone(false)
    }
  })

  

  let form = props.form;

  // let name = `${index}-${p.slugValue}`;
  let name = `${p.slugValueNew}`;


  let elemType = p.questionType;
  let isRequired = p.isRequired;



  useEffect(() => {
    if(form.getFieldsValue()[name] && voiceInput == null){
      setvoiceInput(form.getFieldsValue()[name].summary)
    }
  })

  useEffect(() => {
    if(form.getFieldsValue()[name]){
      setvoiceInput(form.getFieldsValue()[name].summary)
    }
  },[name])


  useEffect(() => {

    if (props.record)
      if (form.getFieldsValue()) {

        let valueField = form.getFieldsValue([name]);
        console.log(valueField, "valllllllllllllllllll", form.getFieldsValue()[name]);

        let fieldVal = valueField[name] ? valueField[name] : {}

        let val = fieldVal.answer


        if (p['questionType'] == 'TABLE') {
          // console.log({ ...fieldVal }, "fildddtablelll");
          // var tableValueObj = {};
          // Object.keys(fieldVal).map((obj, index) => {

          //   if (index == 0) {
          //     console.log(obj, "dedede", fieldVal[obj]);
          //   }
          //   if (fieldVal[obj]) {
          //     tableValueObj = {
          //       ...tableValueObj,
          //       [obj]: {
          //         answer: "25-5-20"
          //       }
          //     }

          //   }


          // })
          // console.log(tableValueObj, "tablejkjk");
          // let tableObj = {
          //   "10": {
          //     answer: "25-5-20"
          //   },
          //   "00": {
          //     answer: "Female"
          //   }
          // };
          // console.log(tableValueArr, "hfghghghg", { ...tableValueArr });
          // form.setFieldsValue({
          //   [name]: { ...tableValueArr }

          // })
        //   form.setFieldsValue({
           
        //     [name]: { ...val } // simple and previously used assigning value to ui code
           
        //   })
        
             const formattedValues = {};
          Object.keys(val || {}).forEach((key) => {
            const field = val[key];
            if (field?.answer) {
              // Check if `answer` is a valid ISO date or timestamp
              const isDate = moment(field.answer, moment.ISO_8601, true).isValid();
              if (isDate) {
                formattedValues[key] = {
                  ...field,
                  answer: moment(field.answer), // Convert to moment for DatePicker compatibility
                };
              } else {
                formattedValues[key] = field; // Leave non-date fields as is
              }
            } else {
              formattedValues[key] = field; // Keep empty or undefined fields unchanged
            }
          });

          // Set the transformed values in the form
          form.setFieldsValue({
            [name]: formattedValues,
          });

        
        
        }
        // if (val && val.length > 0 && !val.find((a) => a == area.name)) {
        //   val.push(area.name);
        // }
        // if (!val) {
        //   val = [area.name]
        // }

        // fieldVal.answer = val;

        // form.setFieldsValue({
        //   [name]: fieldVal
        // })

      }
  })
  //========================= update option selection on image click 
  const updateFormValues = (area) => {
   console.log('in update out')
    // let name = p.slugValue;
    if (p['questionType'] == 'RADIO_BUTTON') {
      let val = {};
      val = { answer: area.name }
      form.setFieldsValue({
        [name]: val
      })
    }

    if (p['questionType'] == 'CHECK_BOX') {
      let valueField = form.getFieldsValue([name]);
      let fieldVal = valueField[name] ? valueField[name] : {}
      let val = fieldVal.answer

      if(val && val.length > 0 && !val.find((a)=>a == area.name)){
        val.push(area.name);
      }
      if(!val){
        val = [area.name]
      }
      
      fieldVal.answer = val;

      form.setFieldsValue({
        [name]: fieldVal
      })
    }

    if (props.rerenderCustom) {
      console.log('in update')
      props.rerenderCustom()
    }


    if (props.rerenderCustomF) {
      console.log('in rerenderCustomF')
      props.rerenderCustomF(false)
    }
  }


//==================== update summary in digital form 
  const updateSummary = (valEvent) => {
    let valueField = form.getFieldsValue([name]);
    if (p.questionType == 'CHECK_BOX') {
      if (valueField[name] != undefined) {
        let val = valueField[name];
        let obj2 = { ansText: 'summary', summary: valEvent };
        let i = p.checkboxList.length;
        val[i] = obj2;

        form.setFieldsValue({
          [name]: val
        })
      }
    } else {
      form.setFieldsValue({
        [name]: {
          summary: valEvent
        }
      })
    }
  }


  const confirm = () => {
    setsubmitDone(false)
    let resetFlag = false;
    let values = form.getFieldsValue();
    Object.keys(values).map((key) => {
      if (key == name) {
        resetFlag = true;
      }
      if (resetFlag == true) {
        console.log(key)
        form.setFieldsValue({
          [key]: undefined
        })
        if (props.rerenderCustomF) {
          props.rerenderCustomF('noanswer')
        }

      }
    })
  }


  const getTipPosition=(area)=>{
    return { top: `${area.center[1]}px`, left: `${area.center[0]}px` };
}

  let ansFlag = false; //================ answer submitted flag 

  let formValues = form.getFieldsValue();
  let valUpdated = formValues[name];


  if ((elemType == 'RADIO_BUTTON' || elemType == 'CHECK_BOX') && valUpdated && valUpdated.answer && submitDone == true) {
    ansFlag = true;
  }

  if (valUpdated && valUpdated.length > 0 && submitDone == true) {
    valUpdated.forEach((item) => {
      if (item.ansText != undefined) {
        ansFlag = true
      }
    })
  }


  let disabledFlag = true;


  if (elemType == 'FREE_TEXT' || elemType == 'MULTI_LINE' || elemType == 'SINGLE_LINE' || elemType == 'NUMBER'
    || elemType == 'DATE' || elemType == 'FILE' || elemType == 'TABLE' || elemType == 'RADIO_BUTTON' || elemType == 'CHECK_BOX') {
    disabledFlag = false;
  }

  disabledFlag = isRequired == null ? false : isRequired;

  // if ((elemType == 'RADIO_BUTTON' || elemType == 'CHECK_BOX') && valUpdated && valUpdated.answer) {
  //   disabledFlag = false;
  // }

  if (disabledFlag == true) {
    if (valUpdated && valUpdated.length > 0) {
      valUpdated.forEach((item) => {
        if (item.ansText != undefined) {
          disabledFlag = false
        }
      })
    }
    if (valUpdated && valUpdated.answer) {
      disabledFlag = false
    }
  }

  
  let width = '200px';
  if (window) {
    width = window.screen.width;
  }
  let right = 0;
  let left = 0;
  if (width > 650) {
    right = '20%';
    left = '20%'
  }

  if (props.chat == true && loading == true) {
    return 'loading...'
  }

  // window.navigator.mediaDevices.getUserMedia({ audio: true })
  // .then(stream => {
  //   const mediaRecorder = new MediaRecorder(stream);
  //   // mediaRecorder.start();
  //   console.log(mediaRecorder)
  // });

  const onChange = (e,m,i) => {

    if(props.chat == true){
      setflag(!flag)
    }
    if (props.rerenderCustom) {
      props.rerenderCustom()
    }
  }

  ///  -------------------------------------------------------

  const next = () => {
    let flag = disabledFlag;
    let formValues = form.getFieldsValue();
    let questionValue = formValues[name]

    if (disabledFlag == true) {
      if (questionValue && questionValue.length > 0) {
        questionValue.forEach((item) => {
          if (item.ansText != undefined) {
            flag = false
          }
        })
      }
      if (questionValue && questionValue.answer) {
        flag = false
      }
    }

    if (flag == true) {
      message.warning('Please answer the question')
    }
    if (flag == false) {
      if (ansFlag == true) {
        if (props.rerenderCustomF) {
          props.rerenderCustomF('noanswer')
        }
      } else {
        if(SpeechRecognition){
          SpeechRecognition.stopListening()
        }
        // resetTranscript()
        updateVoiceCaptureInput(voiceInput)
        setvoiceInput('')
        setspeechstarted(false)
        // stopspeech()
        setsubmitDone(true)

        if (props.rerenderCustomF) {
          props.rerenderCustomF()
        }
      }
    }
  }


  const enterArea=(area) =>{
    setselectedArea(area)
}

const leaveArea=(area) =>{
    setselectedArea(null)
}
  const prev = () => {
    SpeechRecognition.stopListening() //=============== stop voice recognition
    // resetTranscript()//======== reset script 
    props.setActiveStepPrev() //=========== update active state index to prev index 
    setvoiceInput('')
    setspeechstarted(false)
    // stopspeech()
    setsubmitDone(false)
  }


  const reset = () => {
    SpeechRecognition.stopListening() //=============== stop voice recognition
    // resetTranscript()//======== reset script 
    form.resetFields() //====== reset form
    props.resetStates()
    props.setformReseted(true)
    setvoiceInput('')
    setspeechstarted(false)
    // stopspeech()
  }


  const updateVoiceCaptureInput = (valText) => {
  
    // setvoiceInput(valText)
    let fieldVal = form.getFieldsValue()[name]

    if(fieldVal){
      // let obj = {...fieldVal}
      // obj.summary = valText;
      // console.log(name, obj)
      form.setFieldsValue({
        [name]: {summary:valText}
      })
    }
  }

  const fnCalculatePainScore = () => {
    let formValues = form.getFieldsValue();
    

    var totalPainScore = null;
    if (props.record.selectedPainQue !== '' && props.record.selectedPainQue !== null && Object.keys(formValues).length) {
      JSON.parse(props.record.selectedPainQue).map((painQue, index) => {
        // console.log(painQue, "aaabbbbbbb");
        var slugValue = painQue.slugValue
        Object.keys(formValues).map((slug, index) => {
          var removeLast8 = slug.slice(0, -8);
          
          if (removeLast8 == slugValue) {
         
            if (formValues[slug].answer !== undefined) {

              totalPainScore += (+formValues[slug].answer);
             
            }
          }
        });
        
      })

      var obj2 = {
        answer: `${totalPainScore}`
      }
      form.setFieldsValue({
        [name]: obj2
      })

    }

    return (
      <>
        {
          totalPainScore !== null ?
            // <Form.Item name="totalPainScore">
            <>
              <Form.Item name={[name, 'answer']} style={{ flex: 1, marginBottom: '10px', marginRight: '5px' }}>
                <h4 style={{ marginBottom: 10, color:'#00003B' }}>
                  {
                    props.record.questionTitle + " " +
                    totalPainScore
                  }
                </h4>


              </Form.Item>
            </>
            : <></>

        }

      </>
    )
  }
  let showLabel = p.questionType == 'FILL_IN_BLANKS' ? false : true

  return (
    < >
      {/* {ansFlag == true &&
        <>
          <div>
            {valUpdated.length > 0 && valUpdated.map((item) => {
              if (item.ansText != undefined) {
                return (
                  <div style={{ textAlign: 'right' }}>
                    {
                      item.ansText != 'summary' &&
                      <h4>{item.ansText}</h4>
                    }
                    <p style={{ color: 'grey' }}>{item.ansSummary}</p>
                  </div>
                )
              }
            })}
          </div>

          <div>
            {valUpdated && valUpdated.answer &&
              <div style={{ textAlign: 'right' }}>
                <h4>{valUpdated.answer}</h4>
                <p style={{ color: 'grey' }}>{valUpdated.summary}</p>
              </div>}
          </div>


          <div style={{ textAlign: 'right' }}>
          <Popconfirm
            title="Editing This question will reset subsequent questions, Are you sure ?"
            onConfirm={confirm}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
                  <Button type="link" onClick={()=>{

                  }}> Edit <EditOutlined/></Button>

          </Popconfirm>
          </div>

        </>
      } */}


      {/* <div style={ansFlag == true ? { display: 'none' } : props.chat == true ? { marginBottom: '150px' } : { marginBottom: 0 }}> */}

       {/* <div style={props.chat == true ? { marginBottom: '150px' } : { marginBottom: 0 }}> */}
      <div style={{ marginBottom: 0 }}>
        {
          elemType == "PAIN_SCORE_QUESTION" ? <></> :
            <>
              <Form.Item
                // label={showLabel == true ? p.questionTitle : ''} 
                style={{color:'#00003B'}}
                name={[name, 'answer']} rules={
                  [
                    { required: disabledFlag, message: 'Required' },
                    ({ getFieldValue }) => ({
                      validator: (rule, value) => {
                        if (value != undefined && value != null && value != '' && elemType == 'NUMBER') {
                          if (!value.toString().trim().match("^[0-9.]+$")) {
                            return Promise.reject(`Characters are not allowed, please enter numeric value.`);
                          }
                        }
                        return Promise.resolve();
                      }
                    })
                  ]
                }>
                {renderElement(props, form, p, name, elemType, onChange, uploadList, { answers: true })}
              </Form.Item>


              {p.refImage && p.refImage != null &&
                <div style={{ marginBottom: 30 }}>
                  {
                    selectedArea &&
                    <span className="tooltip"
                      style={{ ...getTipPosition(selectedArea), color:'#00003B' }}>
                      {selectedArea && selectedArea.name}
                    </span>
                  }
                  <ImageComp
                    p={p}
                    updateFormValues={updateFormValues}
                    enterArea={enterArea}
                    leaveArea={leaveArea} />
                </div>
              }
            </>
        }
          
      </div>
      {/* { props.chat == true &&
        chatButtons(name, next, prev, reset, form, 
          updateVoiceCaptureInput, setvoiceInput, props, submitDone, voiceInput,
          setspeechstarted, speechstarted,
          setspeechprocessing, speechprocessing)
      } */}


      {/* {props.chat == false && */}
       
      {( props.record.addNote && props.chat == false) &&
          <Form.Item name={[name,'summary']} style={{ flex: 1, marginBottom: '10px', marginRight: '5px' }}>
            <Input value={voiceInput} placeholder="Note"
              style={{ width: '100%', fontSize: '15px', borderRadius: '10px', color:'#00003B' }}
              onChange={(e) => {
                let valEvent = e.target.value;
                updateSummary(valEvent)
                setvoiceInput(valEvent)
              }} />
          </Form.Item>
      }
      
      {
        props.record.questionType == 'PAIN_SCORE_QUESTION' &&
        fnCalculatePainScore()


      }
    </>
  );

}

export default RenderResponseWithAnsChat;